import useCurrency from '@hooks/useCurrency';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { calculatePrice } from '../helpers';
import { UserInvoice, UserInvoiceSetting } from '../types';

interface Props {
    invoice?: UserInvoice;
    setting?: UserInvoiceSetting;
    isCredit?: boolean;
}

export const InvoicePriceComponent = ({ invoice, setting, isCredit }: Props) => {
    const { t } = useTranslation('invoice');
    const { watch } = useFormContext();
    const { getSymbol } = useCurrency();
    const currencyCode = watch('currency');
    const data = watch(['items', 'credits', 'taxes']);
    const prices = useMemo(() => calculatePrice(data, invoice, setting), [data, invoice, setting]);

    const translation = {
        taxes: t('invoiceForm.priceComponent.totalTaxes'),
        total: t('invoiceForm.priceComponent.total'),
        before_taxes: t('invoiceForm.priceComponent.totalWithoutTaxes'),
        credits_total: t('invoiceForm.priceComponent.totalCredits'),
        total_with_credits: t('invoiceForm.priceComponent.totalPayable')
    };

    return (
        <div className="tw-card-flat tw-grid tw-grid-cols-2 tw-gap-x-4 tw-p-2 tw-px-4 tw-text-right">
            {Object.entries(prices)
                .filter(([key]) => !isCredit || !['credits_total', 'total_with_credits'].includes(key))
                .map(([key, value]) => {
                    return (
                        <React.Fragment key={key}>
                            <span className="tw-text-sm tw-font-bold">{translation[key]}</span>
                            <span className="tw-whitespace-nowrap">
                                {value} {getSymbol(currencyCode)}
                            </span>
                        </React.Fragment>
                    );
                })}
        </div>
    );
};
